import type { Workitem } from '@rhythmic/db/types'
import type { WorkitemSearchFilters } from '@rhythmic/types'
import type { Ref, UseLiveQueryReturn } from '@tanstack/vue-db'
import { and, eq, inArray, or, useLiveQuery } from '@tanstack/vue-db'
import { useRhythmicLogger } from '#imports'
import { getWorkitemsCollection } from '../contexts'

export function useWorkitemsByTeamId(
  teamId: string | null | undefined,
  filters?: WorkitemSearchFilters,
): UseLiveQueryReturn<Workitem> | undefined {
  const logger = useRhythmicLogger('useWorkitemsByTeamId')
  if (!teamId || teamId === null || teamId === undefined || teamId === '') {
    return undefined
  }

  const collection = getWorkitemsCollection(teamId)

  const getStatusesWhere = ({ w }: { w: Ref<Workitem> }) => {
    const statuses = filters?.statuses ?? []
    const shouldFilter = statuses.length > 0

    return or(eq(shouldFilter, false), inArray(w.status, statuses))
  }

  const getTypesWhere = ({ w }: { w: Ref<Workitem> }) => {
    const types = filters?.types ?? []
    const shouldFilter = types.length > 0

    return or(eq(shouldFilter, false), inArray(w.workitem_type, types))
  }

  const getWorkitemsWhere = ({ w }: { w: Ref<Workitem> }) => {
    return and(getStatusesWhere({ w }), getTypesWhere({ w }))
  }

  const query = useLiveQuery((builder) =>
    builder
      .from({ w: collection })
      .where(getWorkitemsWhere)
      .orderBy(({ w }) => w.priority, 'desc'),
  )

  return query
}
